// extracted by mini-css-extract-plugin
export default {"introduction":"IntroComponent_introduction__GhOlc"};